export enum ShowLuxuryTaxType {
	NO = "NO",
	YES = "YES",
}
